import { useState, useEffect } from "react";
import Select from "react-select";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { toast } from "react-toastify";
import { FaPlusCircle } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { useCallback } from "react";



const API = process.env.REACT_APP_API_URL;
const PDFURL = process.env.REACT_APP_PDF_URL;
const VATVALUE = Number(process.env.REACT_APP_VAT_VALUE || 0);

function Casefilecreate() {

  const { id } = useParams();
  const [isOpen, setIsOpen] = useState(false);

  const [serviceOptions, setServiceOptions] = useState([]);
  const [expenseOptions, setExpenseOptions] = useState([]);
  const [displayExpense, setdisplayExpense] = useState(false);

  const fetchMasterData = async () => {
  try {
    const token = localStorage.getItem("token");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(`${API}/service-expense-get`, config);

    setServiceOptions(res.data.services);
    setExpenseOptions(res.data.expenses);
    setdisplayExpense(res.data.role === 'admin');

  } catch (err) {
    console.log(err);
  }
};


  const [customer, setCustomer] = useState({
    contact: "971",
    name: "",
    vat: "",
  });

  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedExpenses, setSelectedExpenses] = useState([]);

  const [serviceRows, setServiceRows] = useState([]);
  const [expenseRows, setExpenseRows] = useState([]);

  const [activeServiceIndex, setActiveServiceIndex] = useState([]);
  const [activeExpenseIndex, setActiveExpenseIndex] = useState([]);

  const [totals, setTotals] = useState({
    serviceSubtotal: 0,
    expenseSubtotal: 0,
    vat: 0,
    grandTotal: 0,
    margin: 0,
     totalDiscount: 0,
  });

  /* ================= TOGGLES ================= */

  const toggleServiceComment = (index) => {
    setActiveServiceIndex((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };

  const toggleExpenseComment = (index) => {
    setActiveExpenseIndex((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };

  /* ================= SELECT ================= */

  const handleServiceChange = (selected) => {
    const selectedList = selected || [];
    setSelectedServices(selectedList);

    let updated = [...serviceRows];

    selectedList.forEach((item) => {
      if (!updated.find((r) => r.id === item.value)) {
        updated.push({
          id: item.value,
          name: item.label,
          qty: 1,
          rate: item.price,
          disc: 0,
          comment: "",
        });
      }
    });

    updated = updated.filter((row) =>
      selectedList.find((s) => s.value === row.id)
    );

    setServiceRows(updated);
  };

  const handleExpenseChange = (selected) => {
    const selectedList = selected || [];
    setSelectedExpenses(selectedList);

    let updated = [...expenseRows];

    selectedList.forEach((item) => {
      if (!updated.find((r) => r.id === item.value)) {
        updated.push({
          id: item.value,
          name: item.label,
          qty: 1,
          rate: item.price,
          disc: 0,
          comment: "",
        });
      }
    });

    updated = updated.filter((row) =>
      selectedList.find((s) => s.value === row.id)
    );

    setExpenseRows(updated);
  };

  /* ================= UPDATE ================= */

  const updateService = (index, field, value) => {
    const updated = [...serviceRows];
    updated[index][field] = Number(value) || 0;
    setServiceRows(updated);
  };

  const updateExpense = (index, field, value) => {
    const updated = [...expenseRows];
    updated[index][field] = Number(value) || 0;
    setExpenseRows(updated);
  };

  const updateServiceComment = (index, value) => {
    const updated = [...serviceRows];
    updated[index].comment = value;
    setServiceRows(updated);
  };

  const updateExpenseComment = (index, value) => {
    const updated = [...expenseRows];
    updated[index].comment = value;
    setExpenseRows(updated);
  };

  /* ================= CALCULATION ================= */

  
  useEffect(() => {

    let serviceWithDisc = 0;
    let expenseWithDisc = 0;

     let serviceDiscount = 0;
     let expenseDiscount = 0;
    

    serviceRows.forEach((r) => {
      const qty = Number(r.qty) || 0;
      const rate = Number(r.rate) || 0;
      const disc = Number(r.disc) || 0;

      serviceWithDisc += qty * rate - disc;
      serviceDiscount += disc;
    });

    expenseRows.forEach((r) => {
      const qty = Number(r.qty) || 0;
      const rate = Number(r.rate) || 0;
      const disc = Number(r.disc) || 0;

      expenseWithDisc += qty * rate - disc;
      expenseDiscount += disc;
    });
   
    const vat = (serviceWithDisc + expenseWithDisc) * VATVALUE;

    const margin = serviceWithDisc - expenseWithDisc;

    const totalDiscount = serviceDiscount + expenseDiscount;

     

    setTotals({
      serviceSubtotal: serviceWithDisc,
      expenseSubtotal: expenseWithDisc,
      vat,
      grandTotal: serviceWithDisc + (displayExpense ? expenseWithDisc : 0) + vat,
      margin,
       totalDiscount,
    });

    

  }, [serviceRows, expenseRows, displayExpense]);

  const [viewMode, setViewMode] = useState("full");

  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);

  const [customerOptions, setCustomerOptions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [contactLocked, setContactLocked] = useState(false);

  const fetchCustomer = async (contact) => {
  try {
    const token = localStorage.getItem("token");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(
      `${API}/customers/search/${contact}`,
      config
    );

    if (res.data && res.data.length > 0) {
      const options = res.data.map((item) => ({
        value: item.id,
        label: `${item.name} (${item.phone})`,
        data: item,
      }));

      setCustomerOptions(options);
      setShowDropdown(true);
    } else {
      setCustomerOptions([]);
      setShowDropdown(false);
    }

  } catch (err) {
    console.log(err);
  }
};

const handleContactChange = (value) => {
  if (contactLocked) return;

  setCustomer((prev) => ({
    ...prev,
    contact: value,
  }));

  if (value.length > 6) {
    fetchCustomer(value);
  } else {
    setCustomerOptions([]);
    setShowDropdown(false);
  }
};

const handleSelectCustomer = (item) => {
  const data = item.data;
 
  setCustomer({
    contact: data.phone,
    name: data.name,
    vat: data.vat || "",
    address: data.address || "",
  });

  setContactLocked(true);
  setShowDropdown(false);
  setCustomerOptions([]);
};

const [quotationComment, setQuotationComment] = useState("");
const [invoiceComment, setInvoiceComment] = useState("");
const [loading, setLoading] = useState(false);

const [showServiceModal, setShowServiceModal] = useState(false);
const [newServiceName, setNewServiceName] = useState("");
const [newServicePrice, setNewServicePrice] = useState("");


const handleAddService = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(
      `${API}/services`,
      {
        name: newServiceName,
        price: newServicePrice,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success("Service added 🚀");
    const newService = res.data.data;
    const option = {
      value: newService.id,
      label: newService.name,
      price: newService.price,
    };

    setServiceOptions((prev) => [option, ...prev]); 

    // reset + close
    setNewServiceName("");
    setNewServicePrice("");
    setShowServiceModal(false);

  } catch (err) {
      console.log(err);

      if (err.response) {
        if (err.response?.status === 401) {
            toast.error("Unauthorized token");
            localStorage.removeItem("token");
            window.location.href = "/login";
          }
        if (err.response.data.message) {
          toast.error(err.response.data.message);
        } else if (err.response.data.errors) {
          const errors = err.response.data.errors;

          Object.values(errors).forEach((messages) => {
            toast.error(messages[0]);
          });
        } else {
          toast.error("Validation failed ❌");
        }
      } else {
        toast.error("Server not responding ❌");
      }
    }
};


const [showExpenseModal, setShowExpenseModal] = useState(false);
const [newExpenseName, setNewExpenseName] = useState("");
const [newExpensePrice, setNewExpensePrice] = useState("");

const handleAddExpense = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(
      `${API}/expenses`,
      {
        name: newExpenseName,
        price: newExpensePrice,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const newExpense = res.data;

    const option = {
      value: newExpense.id,
      label: newExpense.name,
      price: newExpense.price,
    };

    setExpenseOptions((prev) => [option, ...prev]);

    setNewExpenseName("");
    setNewExpensePrice("");
    setShowExpenseModal(false);

    toast.success("Expense added 🚀");
  } catch (err) {
    console.log(err);

    if (err.response) {
      if (err.response?.status === 401) {
        toast.error("Unauthorized token");
        localStorage.removeItem("token");
        window.location.href = "/login";
      }

      if (err.response.data.message) {
        toast.error(err.response.data.message);
      } else if (err.response.data.errors) {
        const errors = err.response.data.errors;

        Object.values(errors).forEach((messages) => {
          toast.error(messages[0]);
        });
      } else {
        toast.error("Validation failed ❌");
      }
    } else {
      toast.error("Server not responding ❌");
    }
  }
};


const fetchCaseFile = useCallback(async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.get(`${API}/casefile/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const data = res.data.data;

    setCustomer(data.customer);
    setDate(data.date);
    setQuotationComment(data.quotationComment || "");
    setInvoiceComment(data.invoiceComment || "");

    /* ================= SERVICES ================= */

    const serviceActiveIndexes = [];

    const services = data.services.map((s, index) => {
      if (s.comment && s.comment.trim() !== "") {
        serviceActiveIndexes.push(index); // ✅ open comment
      }

      return {
        id: s.id,
        name: s.name,
        qty: s.qty,
        rate: s.rate,
        disc: s.disc,
        comment: s.comment || "",
      };
    });

    setServiceRows(services);

    setSelectedServices(
      services.map((s) => ({
        value: s.id,
        label: s.name,
        price: s.rate,
      }))
    );

    setActiveServiceIndex(serviceActiveIndexes); // ✅ IMPORTANT

    /* ================= EXPENSES ================= */

    const expenseActiveIndexes = [];

    const expenses = data.expenses.map((e, index) => {
      if (e.comment && e.comment.trim() !== "") {
        expenseActiveIndexes.push(index); // ✅ open comment
      }

      return {
        id: e.id,
        name: e.name,
        qty: e.qty,
        rate: e.rate,
        disc: e.disc,
        comment: e.comment || "",
      };
    });

    setExpenseRows(expenses);

    setSelectedExpenses(
      expenses.map((e) => ({
        value: e.id,
        label: e.name,
        price: e.rate,
      }))
    );

    setActiveExpenseIndex(expenseActiveIndexes); // ✅ IMPORTANT
    setViewMode(data.print_status || "full");

  } catch (err) {
    console.log(err);
    toast.error("Failed to load case file");
  }
}, [id]);


useEffect(() => {
  document.title = "Update Case File | Admin Panel";
  fetchMasterData();
  fetchCaseFile();
}, [fetchCaseFile]);


const handleUpdateCaseFile = async () => {
  try {
    setLoading(true);

    const token = localStorage.getItem("token");

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const payload = {
      customer,
      services: serviceRows,
      expenses: expenseRows,
      totals,
      quotationComment,
      invoiceComment,
      date,
    };

    const res = await axios.put(
      `${API}/casefile-update/${id}`,
      payload,
      config
    );

    if (res.data?.success) {
      toast.success(res.data.message || "Case file updated successfully 🚀");

    
    } else {
      toast.error(res.data?.message || "Update failed");
    }

  } catch (err) {
    console.log(err);

    if (err.response?.status === 422) {
      const errors = err.response.data.errors;
      const firstError = Object.values(errors)[0]?.[0];
      toast.error(firstError || "Validation error");
      return;
    }

    toast.error(
      err.response?.data?.message || "Server error, please try again"
    );

  } finally {
    setLoading(false);
  }
};

const updatePrintStatus = async (value) => {
  try {
    const token = localStorage.getItem("token");

    await axios.patch(
      `${API}/casefile-print-status/${id}`,
      { print_status: value },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success("Print mode updated");
  } catch (err) {
    console.log(err);
    toast.error("Failed to update print mode");
  }
};

const handlePrintModeChange = (value) => {
  setViewMode(value);
  updatePrintStatus(value);
};


const openInvoice = (type, action) => {
  const token = localStorage.getItem("token");

  const url = `${PDFURL}/pdf/data/${id}/${action}/${type}?token=${token}`;

  window.open(url, "_blank");
};

  /* ================= UI ================= */

  return (
    <>
    <div className="flex min-h-screen bg-gradient-to-r from-blue-50 via-purple-50 to-pink-50">

      <Sidebar isOpen={isOpen} toggleSidebar={() => setIsOpen(!isOpen)} />
      <div className="flex-1 flex flex-col">
        <Header toggleSidebar={() => setIsOpen(!isOpen)} />

        <main className="p-6 space-y-6">

          {/* ================= CUSTOMER ================= */}
          <div className="bg-white p-4 rounded shadow grid grid-cols-1 md:grid-cols-4 gap-3">

          {/* CONTACT */}
              <div className="flex flex-col relative">
                <label className="text-sm font-medium mb-1">Contact</label>

               <input
                  className="border p-2 rounded"
                  placeholder="Enter Contact"
                  value={customer.contact}
                  readOnly={contactLocked}
                  onChange={(e) => handleContactChange(e.target.value)}
                />

                {/* DROPDOWN */}
                {showDropdown && customerOptions.length > 0 && (
                  <div className="absolute top-full left-0 right-0 bg-white border shadow z-10 max-h-40 overflow-y-auto">
                    {customerOptions.map((item) => (
                      <div
                        key={item.value}
                        className="p-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() => handleSelectCustomer(item)}
                      >
                        {item.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>

          {/* NAME */}
          <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">Customer Name</label>
              <input
                className="border p-2 rounded"
                placeholder="Enter Name"
                value={customer.name}
                onChange={(e) =>
                  setCustomer({ ...customer, name: e.target.value })
                }
              />
            </div>

          {/* VAT */}
          <div className="flex flex-col">
            <label className="text-sm font-medium mb-1">VAT Number</label>
            <input
              className="border p-2 rounded"
              placeholder="Enter VAT"
              value={customer.vat}
              onChange={(e) =>
                setCustomer({ ...customer, vat: e.target.value })
              }
            />
          </div>

          {/* ADDRESS */}
          <div className="flex flex-col">
              <label className="text-sm font-medium mb-1">Address</label>
              <input
                className="border p-2 rounded"
                placeholder="Enter Name"
                value={customer.address}
                onChange={(e) =>
                  setCustomer({ ...customer, address: e.target.value })
                }
              />
            </div>


          {/* DATE */}
          <div className="flex flex-col">
          <label className="text-sm font-medium mb-1">Date</label>
          <input
              type="date"
              className="border p-2 rounded"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
        </div>

        </div>

          {/* ================= DROPDOWNS ================= */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
           <div className="bg-white p-4 rounded shadow">
              <div className="flex justify-between items-center mb-2">
                <h3 className="font-bold">Select Services</h3>  
                <FaPlusCircle className="cursor-pointer" onClick={() => setShowServiceModal(true)} />
              </div>

             <Select
                isMulti
                options={serviceOptions}
                value={selectedServices}
                onChange={handleServiceChange}
                styles={{
                  control: (base) => ({
                    ...base,
                    cursor: "pointer",
                  }),
                  option: (base) => ({
                    ...base,
                    cursor: "pointer",
                  }),
                }}
              />
            </div>
                {displayExpense && (
                  <div className="bg-white p-4 rounded shadow">
                    <div className="flex justify-between items-center mb-2">
                      <h3 className="font-bold">Select Expenses</h3>

                      {/* ➕ Add Button */}
                      <FaPlusCircle
                        className="cursor-pointer"
                        onClick={() => setShowExpenseModal(true)}
                      />
                    </div>

                    <Select
                      isMulti
                      options={expenseOptions}
                      value={selectedExpenses}
                      onChange={handleExpenseChange}
                      styles={{
                        control: (base) => ({ ...base, cursor: "pointer" }),
                        menu: (base) => ({ ...base, cursor: "pointer" }),
                        option: (base) => ({ ...base, cursor: "pointer" }),
                      }}
                    />
                  </div>
                )}
          </div>

          {/* ================= SERVICES TABLE ================= */}
          <div className="bg-white p-4 rounded shadow">
            <div className="flex justify-between items-center mb-3">
  
                {/* LEFT TITLE */}
                <h3 className="font-bold text-lg">Services</h3>

                {/* RIGHT CONTROLS */}
                <div className="flex items-center gap-6">

                  {/* RADIO BUTTONS */}
                   {displayExpense && (
                  <div className="flex items-center gap-4 text-sm">

                    <label className="flex items-center gap-1 cursor-pointer">
                      <input
                        type="radio"
                        name="viewMode"
                        value="full"
                        checked={viewMode === "full"}
                        onChange={() => handlePrintModeChange("full")}
                      />
                      Full
                    </label>

                    <label className="flex items-center gap-1 cursor-pointer">
                      <input
                        type="radio"
                        name="viewMode"
                        value="onlyservice"
                        checked={viewMode === "onlyservice"}
                        onChange={() => handlePrintModeChange("onlyservice")}
                      />
                      Service Only
                    </label>
                  </div>
                   )}

                  {/* ACTION DROPDOWN */}
                  <div className="relative group">

                    <button className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700">
                      Actions ▾
                    </button>

                    {/* DROPDOWN */}
                    <div className="absolute right-0 mt-2 w-56 bg-white border rounded shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">

                      <button
                          onClick={() => openInvoice("quotation", "print")}
                          className="w-full text-left px-4 py-2 hover:bg-gray-100"
                        >
                          Print Quotation
                        </button>

                        <button
                          onClick={() => openInvoice("invoice", "print")}
                          className="w-full text-left px-4 py-2 hover:bg-gray-100"
                        >
                          Print Invoice
                        </button>

                        <button
                          onClick={() => openInvoice("quotation", "download")}
                          className="w-full text-left px-4 py-2 hover:bg-gray-100"
                        >
                          Download Quotation
                        </button>

                        <button
                          onClick={() => openInvoice("invoice", "download")}
                          className="w-full text-left px-4 py-2 hover:bg-gray-100"
                        >
                          Download Invoice
                        </button>

                    </div>
                  </div>

                </div>
              </div>
           

            <div className="grid grid-cols-5 gap-2 font-bold border-b pb-2 mb-2">
              <span>Service Name</span>
              <span>Qty</span>
              <span>Rate</span>
              <span>Discount</span>
              <span>Total</span>
            </div>

            {serviceRows.map((row, i) => (
              <div key={row.id} className="mb-2">

                <div
                  className="grid grid-cols-5 gap-2 items-center cursor-pointer"
                  
                >
                  <span onClick={() => toggleServiceComment(i)}>{row.name}</span>

                  <input className="border p-1 rounded"
                    value={row.qty}
                    onChange={(e) => updateService(i, "qty", e.target.value)}
                  />

                  <input className="border p-1 rounded"
                    value={row.rate}
                    onChange={(e) => updateService(i, "rate", e.target.value)}
                  />

                  <input className="border p-1 rounded"
                    value={row.disc}
                    onChange={(e) => updateService(i, "disc", e.target.value)}
                  />

                  <span className="text-blue-600 font-semibold">
                    {(row.qty * row.rate - row.disc).toFixed(2)}
                  </span>
                </div>

                {activeServiceIndex.includes(i) && (
                  <input
                    className="border p-2 w-full mt-2 rounded"
                    placeholder={`Comment for ${row.name}`}
                    value={row.comment}
                    onChange={(e) => updateServiceComment(i, e.target.value)}
                  />
                )}

              </div>
            ))}
          </div>

          {/* ================= EXPENSE TABLE ================= */}
           {displayExpense && (
          <div className="bg-white p-4 rounded shadow">
            <h3 className="font-bold mb-3">Expenses</h3>

            <div className="grid grid-cols-5 gap-2 font-bold border-b pb-2 mb-2">
              <span>Expense Name</span>
              <span>Qty</span>
              <span>Rate</span>
              <span>Discount</span>
              <span>Total</span>
            </div>

            {expenseRows.map((row, i) => (
              <div key={row.id} className="mb-2">

                <div
                  className="grid grid-cols-5 gap-2 items-center cursor-pointer"
                  
                >
                  <span onClick={() => toggleExpenseComment(i)}>{row.name}</span>

                  <input className="border p-1 rounded"
                    value={row.qty}
                    onChange={(e) => updateExpense(i, "qty", e.target.value)}
                  />

                  <input className="border p-1 rounded"
                    value={row.rate}
                    onChange={(e) => updateExpense(i, "rate", e.target.value)}
                  />

                  <input className="border p-1 rounded"
                    value={row.disc}
                    onChange={(e) => updateExpense(i, "disc", e.target.value)}
                  />

                  <span className="text-green-600 font-semibold">
                    {(row.qty * row.rate - row.disc).toFixed(2)}
                  </span>
                </div>

                {activeExpenseIndex.includes(i) && (
                  <input
                    className="border p-2 w-full mt-2 rounded"
                    placeholder={`Comment for ${row.name}`}
                    value={row.comment}
                    onChange={(e) => updateExpenseComment(i, e.target.value)}
                  />
                )}

              </div>
            ))}
          </div>
           )}

          {/* ================= TOTAL ================= */}
           <div className="bg-white p-6 rounded shadow">

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                {/* LEFT SIDE → COMMENTS ONLY */}
                <div className="space-y-4">

                  <div>
                    <label className="block font-medium mb-1">
                      Quotation Comment
                    </label>
                    <textarea
                      className="w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-purple-300"
                      rows={3}
                      placeholder="Enter quotation comment..."
                      value={quotationComment}
                      onChange={(e) => setQuotationComment(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block font-medium mb-1">
                      Invoice Comment
                    </label>
                    <textarea
                      className="w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-purple-300"
                      rows={3}
                      placeholder="Enter invoice comment..."
                      value={invoiceComment}
                      onChange={(e) => setInvoiceComment(e.target.value)}
                    />
                  </div>

                </div>

                {/* RIGHT SIDE → TOTALS + BUTTON */}
                <div className="flex justify-end">

                  <div className="w-full md:w-96 space-y-3">
                    {displayExpense && (
                    <div className="flex justify-between">
                      <span>Service Total</span>
                      <span>{totals.serviceSubtotal.toFixed(2)}</span>
                    </div>
                     )}
                     {displayExpense && (
                    <div className="flex justify-between">
                      <span>Expense Total</span>
                      <span>{totals.expenseSubtotal.toFixed(2)}</span>
                    </div>
                     )}

                    <div className="flex justify-between">
                        <span>Total Discount</span>
                        <span>{totals.totalDiscount.toFixed(2)}</span>
                      </div>
                    {displayExpense && (
                    <div className="flex justify-between text-red-500">
                      <span>Margin</span>
                      <span>{totals.margin.toFixed(2)}</span>
                    </div>
                    )}

                    <div
                      className={`flex justify-between ${
                        Number(VATVALUE) > 0 && totals.vat > 0 ? "" : "hidden"
                      }`}
                    >
                      <span>VAT</span>
                      <span>{totals.vat.toFixed(2)}</span>
                    </div>

                    <div className="border-t pt-2 flex justify-between font-bold text-lg text-purple-600">
                      <span>Grand Total</span>
                      <span>{totals.grandTotal.toFixed(2)}</span>
                    </div>

                    {/* BUTTON MOVED HERE */}
                    <button
                      onClick={handleUpdateCaseFile}
                      disabled={loading}
                      className="w-full mt-3 bg-purple-600 text-white py-2 rounded hover:bg-purple-700 transition font-medium"
                    >
                      {loading ? "Updating..." : "Update Case File"}
                    </button>

                  </div>

                </div>



              </div>

            </div>

        </main>
      </div>
    </div>

    {showServiceModal && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div className="bg-white w-full max-w-md p-6 rounded-2xl shadow-2xl">
      <h2 className="text-xl font-bold mb-4">Add Service</h2>

      <div className="space-y-4">
        <input
          type="text"
          placeholder="Service Name"
          value={newServiceName}
          onChange={(e) => setNewServiceName(e.target.value)}
          className="w-full border p-3 rounded-lg"
        />

        <input
          type="number"
          placeholder="Price"
          value={newServicePrice}
          onChange={(e) => setNewServicePrice(e.target.value)}
          className="w-full border p-3 rounded-lg"
        />

        <div className="flex gap-3">
          <button
            onClick={() => setShowServiceModal(false)}
            className="w-full bg-gray-300 py-2 rounded-lg"
          >
            Cancel
          </button>

          <button
            onClick={handleAddService}
            className="w-full bg-blue-600 text-white py-2 rounded-lg"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
)}


{showExpenseModal && (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div className="bg-white w-full max-w-md p-6 rounded-2xl shadow-2xl">

      <h2 className="text-xl font-bold mb-4">Add Expense</h2>

      <div className="space-y-4">

        <input
          className="w-full border p-3 rounded-lg"
          placeholder="Expense Name"
          value={newExpenseName}
          onChange={(e) => setNewExpenseName(e.target.value)}
        />

        <input
          className="w-full border p-3 rounded-lg"
          type="number"
          placeholder="Price"
          value={newExpensePrice}
          onChange={(e) => setNewExpensePrice(e.target.value)}
        />

        <div className="flex gap-2">
          <button
            onClick={() => setShowExpenseModal(false)}
            className="w-full bg-gray-300 p-2 rounded"
          >
            Cancel
          </button>

        <button
            type="button"
            onClick={handleAddExpense}
            className="w-full bg-blue-600 text-white p-2 rounded"
          >
            Save
          </button>
        </div>

      </div>

    </div>
  </div>
)}
   </>
    
  );
}

export default Casefilecreate;